export default "__VITE_ASSET__DQc2eBao__"